import { render, staticRenderFns } from "./InquiryVirtualAccount.vue?vue&type=template&id=06c1d840"
import script from "./InquiryVirtualAccount.vue?vue&type=script&lang=js"
export * from "./InquiryVirtualAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports